const modelsTotal = document.getElementById('modelsTotal').value;
export { modelsTotal };
